import './services/monitoring/sentry';
import './utils/errorHandling';
import './utils/frontAuthSecret';
import './index.css';

// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from '@sentry/react';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import { OuchFallback } from './components/common/OuchFallback';
import { store } from './state/state';


const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={{
        api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
        defaults: '2025-05-24',
        capture_exceptions: true,
        debug: import.meta.env.MODE === 'development',
        autocapture: false,
        disable_session_recording: window.location.hostname === 'localhost',
        session_recording: {
          maskAllInputs: false,
          maskTextSelector: null,
        },
      }}
    >
      <Sentry.ErrorBoundary fallback={<OuchFallback />}>
        <Provider store={store}>
          <App />
        </Provider>
      </Sentry.ErrorBoundary>
    </PostHogProvider>
  </React.StrictMode>,
);
